// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import './assets/style.css'
import axios from 'axios'

Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.prototype.appSet = {
  appid:'5f0eae155aae7',
  appkey:'5f0eae155aaed'
};


import {Layout, Icon, Menu, Dropdown, Badge,Divider, Row, Col, Card, Button, Tag, Modal, Descriptions, Input, DatePicker, Upload, Tooltip, Table, PageHeader, Tabs, Select, List, Radio, Spin, Cascader, Switch, TreeSelect, Checkbox, message, Tree} from 'ant-design-vue';

Vue.use(Icon);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Dropdown)
Vue.use(Badge)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Button)
Vue.use(Tag)
Vue.use(Modal)
Vue.use(Descriptions)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(PageHeader)
Vue.use(Tabs)
Vue.use(Select)
Vue.use(List)
Vue.use(Divider)
Vue.use(Radio)
Vue.use(Spin)
Vue.use(Cascader)
Vue.use(Switch)
Vue.use(TreeSelect)
Vue.use(Checkbox)
Vue.use(Tree)
Vue.prototype.$message = message;

router.beforeEach((to, from, next) => {
  console.log("token="+localStorage.getItem('token'))
  if (localStorage.getItem('token')) {
    next();
  }else{
      //没有登录，去跳转登录页
      if(to.path === '/'){
        next();
      }else {
        next({
          path:'/'
        });
      }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js